<template>
    <nav class="px-5 pt-5 bg-primary">

        <div v-for="(navLink, key) in navLinks" :key="key" class="text-white border-b-[1px] border-[#e5a5a5] pb-5 pt-5 xl:min-w-[500px] text-center">
            <NavLink class="w-full font-normal text-[1.5rem] leading-[1vh]" :href="navLink.route" :active="route().current('dashboard')">
                {{ navLink.text }}
            </NavLink>
        </div>
    </nav>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue'
import NavLink from '@/Components/NavLink.vue'

export default {

    components: {
        Icon,
        NavLink
    },
    data() {
        return {
            navLinks: [
                {
                    route: "login",
                    text: "Acesse a plataforma"
                },
                {
                    route: "register",
                    text: "Crie uma conta"
                },
                {
                    route: "terms",
                    text: "Termos de Uso"
                },
                {
                    route: "contact",
                    text: "Fale Conosco"
                },
                {
                    route: "faq",
                    text: "Perguntas Frequentes"
                }
            ]
        }
    }
}
</script>
